export class DisciplinaryAction {
    id!: string
    hrco!: number
    hrRef!: number
    seq!: number
    date?: Date
    code!: string
    incidentDesc!: string
    discAction!: string
    daysSuspended?: number
    warningNoticeYn!: string
    followUpDate?: Date
    notes!: string
    udProgressiveDiscipline!: string
    udEmployeeComments!: string
    udSupervisorComments!: string
    employeeName!: string
    rawTranscription!: string
    status!: string
    createdBy?: string
    createdOn?: Date
    modifiedOn?: Date
}

export interface DisciplinaryActionExtractionResult {
    employeeName: string | null
    incidentDate: string | null
    code: string | null
    incidentDesc: string | null
    discAction: string | null
    daysSuspended: number | null
    warningNoticeYn: string | null
    udProgressiveDiscipline: string | null
    followUpDate: string | null
    udEmployeeComments: string | null
    udSupervisorComments: string | null
    employeeMatches: EmployeeMatchResult[]
}

export interface EmployeeMatchResult {
    hrRef: number
    firstName: string
    lastName: string
    positionCode: string
    jobTitle: string
    confidence: string
}

export interface HrcmCode {
    code: string
    description: string
}

export interface DisciplinaryActionLookups {
    hrcmCodes: HrcmCode[]
}
